import {Component, OnInit} from '@angular/core';
import {Pageable} from "../../../_domains/spring/pageable";
import {ProjectUtilsService} from "../_services/project-utils.service";
import {finalize} from "rxjs/operators";
import {AppMessageService} from "../../../_services/app-message.service";

@Component({
  selector: 'project-document-params',
  templateUrl: './project-document-params.component.html'
})
export class ProjectDocumentParamsComponent implements OnInit {
  selected: any = null;
  showDialog: boolean = false;

  private _reports: Pageable = new Pageable();
  private cdoc = '';
  private _mode = 0;
  private currentPage = 0;
  private _loading: boolean;
  private sorting = '&sort=norder,asc';

  constructor(private messageService: AppMessageService,
              private dataService: ProjectUtilsService) {
  }

  ngOnInit() {
    this._loading = false;
  }

  refresh(cdoc: string, mode: number) {
    this.showDialog = true;
    this.cdoc = cdoc;
    this._mode = mode;
    let filter = '';
    filter = `?page=${this.currentPage || '0'}`;
    filter += (this.sorting || '') !== '' ? this.sorting : '';

    this.loadData(filter);
  }

  get reports(): Pageable {
    return this._reports;
  }


  get loading(): boolean {
    return this._loading;
  }

  get header(): string {
    return `"${this.cdoc || '?'}": ${this._mode===2?'Report': 'Form'} parameters`;
  }

  get dialogStyle(): any {
    return {width: `${window.innerWidth - 100}px`}
  }

  get mode(): number {
    return this._mode;
  }


  handlePageChange(event) {
    let filter = '';
    this.currentPage = (event.rows == 0) ? 0 : Math.floor(event.first / event.rows);
    this.sorting = event.sortField && `&sort=${event.sortField},${event.sortOrder == 1 ? 'asc' : 'desc'}`;
    filter = `?page=${this.currentPage || '0'}`;
    filter += (this.sorting || '') !== '' ? this.sorting : '';

    this.loadData(filter);
  }

  outputRowCellValue(data, len) {
    if (data && data.length) {
      return data.length > len ? (`${data.substring(0, len - 1)}...`) : data;
    }
    return data;
  }

  outputRowDataType(param) {
    const dataType = param.dataType;
    if (dataType === "NUMBER") {
      if (param.decimalPlaces) {
        return `${dataType}:${param.decimalPlaces}`;
      }
    }
    return dataType;
  }

  private loadData(filter?: string) {
    if (this.cdoc.length > 0) {
      this._loading = true;
      this.dataService.getListDictDocParams(this.cdoc, filter)
        .pipe(finalize(() => {
          this._loading = false;
        }))
        .subscribe(
          data => {
            this._reports = data;
          },
          error => {
            this.messageService.showMessage(error);
          }
        );
    }
  }
}
